import { apiClient } from "@/lib/api/client";
import type { NotificationDto, NotificationListDto } from "@/lib/api/types";

export type ListNotificationsParams = {
  limit?: number;
  offset?: number;
  search?: string;
  readState?: "all" | "read" | "unread";
  severity?: "all" | "info" | "warning" | "critical";
  type?: string;
};

export async function listNotifications(params: ListNotificationsParams = {}): Promise<NotificationListDto> {
  const query: Record<string, string | number> = {};
  if (params.limit !== undefined) {
    query.limit = params.limit;
  }
  if (params.offset !== undefined) {
    query.offset = params.offset;
  }
  if (params.search?.trim()) {
    query.search = params.search.trim();
  }
  if (params.readState) {
    query.read_state = params.readState;
  }
  if (params.severity && params.severity !== "all") {
    query.severity = params.severity;
  }
  if (params.type?.trim()) {
    query.type = params.type.trim();
  }
  const { data } = await apiClient.get<NotificationListDto>("/notifications", { params: query });
  return data;
}

export async function markNotificationRead(notificationId: string): Promise<NotificationDto> {
  const { data } = await apiClient.post<NotificationDto>(`/notifications/${notificationId}/read`);
  return data;
}

export async function markAllNotificationsRead(): Promise<{ updated: number }> {
  const { data } = await apiClient.post<{ updated: number }>("/notifications/mark-all-read");
  return data;
}
